import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { SiteOverviewSite, SiteStatusSite } from "../../site-status-types";

function getSiteIdColumn(): MRT_ColumnDef<SiteOverviewSite | SiteStatusSite> {
  return {
    header: "ID",
    accessorKey: "id",
    size: 100,
    filterFn: "includesString"
  };
}

export { getSiteIdColumn };
